import { render } from "./ActivityAttachmentOffcanvas.vue?vue&type=template&id=03df8654&scoped=true&ts=true"
import script from "./ActivityAttachmentOffcanvas.ts?vue&type=script&lang=ts"
export * from "./ActivityAttachmentOffcanvas.ts?vue&type=script&lang=ts"

import "./ActivityAttachmentOffcanvas.scss?vue&type=style&index=0&id=03df8654&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03df8654"]])

export default __exports__